import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const CreateContainer = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  margin-bottom: 32px;
  border: 1px solid #f0f0f5;
`;

export const SlideCard = styled(motion.div)`
  border: 1px solid #f0f0f5;
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  margin-bottom: 24px;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: grid;
  grid-template-columns: 220px 1fr auto;
  gap: 24px;
  position: relative;

  &:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
    border-color: #e2e2e9;
  }
`;

export const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 220px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid #f0f0f5;
  background: #fcfcfe;
`;

export const NoImagePlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f9f9fb;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 0.85rem;
  border: 2px dashed #e2e8f0;
  gap: 8px;

  svg {
    width: 24px;
    height: 24px;
    opacity: 0.5;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-left: 1px solid #f0f0f5;
  padding-left: 24px;
  justify-content: center;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 40px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 20px;
  border: 2px dashed #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  h3 {
    margin: 0;
    color: #1e293b;
    font-size: 1.25rem;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    max-width: 300px;
    line-height: 1.5;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 32px;
  align-items: start;
`;

export const Badge = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  background: #ef4444;
  color: white;
  padding: 6px 16px;
  font-size: 0.7rem;
  font-weight: 700;
  border-bottom-right-radius: 12px;
  border-top-left-radius: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  background: #f1f5f9;
  padding: 6px;
  border-radius: 12px;
  width: fit-content;
  margin-bottom: 24px;
`;

export const Tab = styled.button<{ active: boolean }>`
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => (props.active ? "#fff" : "transparent")};
  color: ${(props) => (props.active ? "#0f172a" : "#64748b")};
  box-shadow: ${(props) => (props.active ? "0 2px 8px rgba(0, 0, 0, 0.05)" : "none")};
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    color: ${(props) => (props.active ? "#0f172a" : "#1e293b")};
  }
`;

export const RoleTag = styled.div<{ userRole: string }>`
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  color: white;
  background: ${(props) => {
    switch (props.userRole) {
      case "store":
        return "#3b82f6";
      case "delivery":
        return "#f59e0b";
      case "customer":
        return "#10b981";
      default:
        return "#64748b";
    }
  }};
`;